module.exports = __webpack_public_path__ + "static/media/Aminé - Yellow A COLORS SHOW.e255f1c3.mp3";